import styled, { css } from 'styled-components';
import React from 'react';

import {
  FaInfoCircle,
  FaExclamationTriangle,
  FaCheckCircle
} from 'react-icons/fa';

export const ChipContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 16px;
  font-size: 14px;

  ${(props) =>
    props.type === 'info' &&
    css`
      background-color: #e0f7fa;
      color: #00796b;
    `}

  ${(props) =>
    props.type === 'warn' &&
    css`
      background-color: #fff3e0;
      color: #e3a723;
    `}

  ${(props) =>
    props.type === 'success' &&
    css`
      background-color: #e8f5e9;
      color: #388e3c;
    `}

  ${(props) =>
    props.type === 'danger' &&
    css`
      background-color: #ffebee;
      color: #d32f2f;
    `}
`;

export const Icon = styled.div`
  margin-right: 8px;

  ${(props) =>
    props.type === 'info' &&
    css`
      color: #00796b;
    `}

  ${(props) =>
    props.type === 'warn' &&
    css`
      color: #e3a723;
    `}

  ${(props) =>
    props.type === 'success' &&
    css`
      color: #388e3c;
    `}
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
`;

export const getIcon = (type) => {
  switch (type) {
    case 'danger':
      return <FaExclamationTriangle />;
    case 'warn':
      return <FaExclamationTriangle />;
    case 'success':
      return <FaCheckCircle />;
    case 'info':
    default:
      return <FaInfoCircle />;
  }
};
